export default __webpack_public_path__ + "static/media/A2-0.561e1f37.png";